(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.product-recommendations[data-url]:not([data-mc-loaded])').forEach(function (section) {
      section.setAttribute('data-mc-loaded', 'true');
      if (section.querySelector('.mc-related-grid')) return;

      var load = function () {
        fetch(section.getAttribute('data-url'))
          .then(function (response) { return response.text(); })
          .then(function (text) {
            var container = document.createElement('div');
            container.innerHTML = text;
            var incoming = container.querySelector('.product-recommendations');
            if (incoming && incoming.innerHTML.trim()) section.innerHTML = incoming.innerHTML;
          })
          .catch(function () {});
      };

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          load();
        }, { rootMargin: '0px 0px 300px 0px' });
        observer.observe(section);
      } else {
        load();
      }
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mc-product-shell]:not([data-mc-ready])').forEach(function (shell) {
      shell.setAttribute('data-mc-ready', 'true');
      var carousel = shell.querySelector('[data-mc-product-carousel]');
      var track = shell.querySelector('[data-mc-product-track]');
      var originals = Array.prototype.slice.call(shell.querySelectorAll('.mc-product-slide'));
      var progress = shell.querySelector('[data-mc-product-progress]');
      var fill = shell.querySelector('[data-mc-product-fill]');
      var previous = shell.querySelector('[data-mc-product-prev]');
      var next = shell.querySelector('[data-mc-product-next]');
      if (!carousel || !track || !originals.length) return;

      var activeIndex = Math.max(0, originals.findIndex(function (slide) { return slide.classList.contains('is-selected'); }));
      var cloneCount = originals.length > 1 ? Math.min(2, originals.length) : 0;
      var timer = null;
      var settleTimer = null;
      var resizing = false;
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (fill) { fill.style.width = (100 / originals.length) + '%'; }

      if (originals.length > 1) {
        originals.slice(-cloneCount).reverse().forEach(function (slide) {
          var clone = slide.cloneNode(true);
          clone.setAttribute('data-mc-clone', 'true');
          clone.setAttribute('aria-hidden', 'true');
          track.insertBefore(clone, track.firstChild);
        });
        originals.slice(0, cloneCount).forEach(function (slide) {
          var clone = slide.cloneNode(true);
          clone.setAttribute('data-mc-clone', 'true');
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        });
      }

      var panelWidth = function () {
        return track.clientWidth / (window.matchMedia('(max-width: 767px)').matches ? 1 : 2);
      };

      var logicalIndex = function () {
        var physical = Math.round(track.scrollLeft / Math.max(1, panelWidth()));
        return ((physical - cloneCount) % originals.length + originals.length) % originals.length;
      };

      var paint = function () {
        activeIndex = logicalIndex();
        if (fill) { fill.style.transform = 'translateX(' + (activeIndex * 100) + '%)'; }
        if (progress) { progress.setAttribute('aria-valuenow', String(activeIndex + 1)); }
        originals.forEach(function (slide, index) {
          slide.classList.toggle('is-selected', index === activeIndex);
        });
      };

      var jumpToPhysical = function (physical) {
        track.scrollTo({ left: physical * panelWidth(), behavior: 'auto' });
      };

      var normalize = function () {
        if (resizing || originals.length < 2) return;
        var width = Math.max(1, panelWidth());
        var physical = Math.round(track.scrollLeft / width);
        if (physical < cloneCount) {
          physical += originals.length;
          jumpToPhysical(physical);
        } else if (physical >= cloneCount + originals.length) {
          physical -= originals.length;
          jumpToPhysical(physical);
        }
        paint();
      };

      var go = function (delta) {
        var physical = Math.round(track.scrollLeft / Math.max(1, panelWidth()));
        track.scrollTo({ left: (physical + delta) * panelWidth(), behavior: reducedMotion ? 'auto' : 'smooth' });
      };

      var stop = function () {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      var start = function () {
        stop();
        if (originals.length < 2 || reducedMotion || document.hidden) return;
        timer = window.setInterval(function () { go(1); }, 7000);
      };

      if (previous) previous.addEventListener('click', function () { go(-1); start(); });
      if (next) next.addEventListener('click', function () { go(1); start(); });
      track.addEventListener('scroll', function () {
        paint();
        if (settleTimer) window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(normalize, 140);
      }, { passive: true });
      track.addEventListener('pointerdown', stop, { passive: true });
      track.addEventListener('pointerup', start, { passive: true });
      window.addEventListener('resize', function () {
        resizing = true;
        jumpToPhysical(cloneCount + activeIndex);
        window.setTimeout(function () { resizing = false; paint(); }, 80);
      });
      document.addEventListener('visibilitychange', start);

      jumpToPhysical(cloneCount + activeIndex);
      paint();
      start();
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeSecondaryAnnouncements() {
      document.querySelectorAll('[data-mc-secondary-announcement]:not([data-mc-ready])').forEach(function (announcement) {
        var textElement = announcement.querySelector('[data-mc-secondary-text]');
        if (!textElement) return;

        announcement.setAttribute('data-mc-ready', 'true');
        var characters = Array.from(textElement.textContent.trim());
        var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!reducedMotion) textElement.textContent = '';

        function collapse() {
          window.setTimeout(function () {
            announcement.classList.remove('is-open');
            window.setTimeout(function () {
              announcement.hidden = true;
            }, 650);
          }, 3000);
        }

        window.setTimeout(function () {
          announcement.classList.add('is-open');

          if (reducedMotion) {
            collapse();
            return;
          }

          window.setTimeout(function () {
            var characterIndex = 0;
            function typeNextCharacter() {
              if (characterIndex >= characters.length) {
                collapse();
                return;
              }
              textElement.textContent += characters[characterIndex];
              characterIndex += 1;
              window.setTimeout(typeNextCharacter, 36);
            }
            typeNextCharacter();
          }, 360);
        }, 1500);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeSecondaryAnnouncements);
    } else {
      initializeSecondaryAnnouncements();
    }
    document.addEventListener('shopify:section:load', initializeSecondaryAnnouncements);
  }());

  } catch(e) { console.error(e); }
})();
})();
